import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './firebase/ProtectedRoute';


import LandingIndex from "./components/landing/landing";
import Login from './components/login/login';
import DashUser from './components/dashUser/dashUser';
import FAQ from './components/faq/FAQ';
import TermsAndConditions from './components/faq/TermsAndConditions';
// import Lanzamiento from './components/lanzamiento/lanzamiento';


function App() {
  
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<LandingIndex/>}/>
          {/* <Route path='/login' element={<Lanzamiento/>}/> */}
          <Route path='/login' element={<Login/>}/>
          <Route path='/faq' element={<FAQ/>}/>
          <Route path='/TermsAndConditions' element={<TermsAndConditions/>}/>


          <Route 
            path='/dashboard'
            element={
              <ProtectedRoute>
                <DashUser />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      
    </div>
  );
}

export default App;
